import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable, signal, WritableSignal} from '@angular/core';
import {
    CatalogoInterface,
    ColindanteItem,
    DireccionItem,
    DistritoItem,
    ElementosTerrenoItem,
    MunicipioItem,
    NuevoProyectoItem,
    ProyectoCreadoItem,
    TenenciaItem
} from '../../../../interfaces/proyecto.interface';
import {environment} from 'src/environments/environment.development';
import {ProyectoPerfil} from "../../../../interfaces/perfil.interface";
import {LoginServices} from "../../../../../auth/login/services/login.service";
import {AreasInterfaces} from "../../../../tramites/components/interfaces/formulario.interfaces";
import {FileHash} from "../../../../../shared/interfaces/file-utils-interface";
import {CacheService} from "../../../../../shared/services/cache-service";

const apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class NuevoProyectoService {
    constructor(private http: HttpClient, private loginServices: LoginServices, private cacheService: CacheService) {
    }

    //Catalogos información general
    listaNaturaleza: WritableSignal<CatalogoInterface[]> = signal([])
    listaTipo: WritableSignal<CatalogoInterface[]> = signal([])
    listaEntorno: WritableSignal<CatalogoInterface[]> = signal([])
    listaRegimen: WritableSignal<CatalogoInterface[]> = signal([])
    listaUsoSuelo: WritableSignal<CatalogoInterface[]> = signal([])


    /**
     * Procesando información requerida del proyecto
     */
    postProyecto(proyecto: NuevoProyectoItem) {
        proyecto.elementosTerreno = this.parseElementoTerreno(proyecto.elementosTerreno);
        proyecto.idInstitucion = this.loginServices.session()?.perfil.idInstitucion;
        //Si no se seleccionó proyecto institución en pantalla significa que el proyecto es privado y se debe enviar a la institucion del usuario logueado(DOT por defecto).
        if (!proyecto.idProyectoInstitucion || proyecto.idProyectoInstitucion == 0) {
            proyecto.idProyectoInstitucion = this.loginServices.session()?.perfil.idInstitucion;
        }
        proyecto.direccion.usuarioCreaModifica = this.loginServices.session()?.perfil?.usuario!;
        proyecto.usuario = this.loginServices.session()?.perfil?.usuario!;
        proyecto.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        return this.http.post<ProyectoCreadoItem>(apiVucUrl + `api/v1.0/proyectos`, proyecto, {observe: 'response'})
    }

    postArea(areas: AreasInterfaces[], idProyecto: number) {
        console.log(`datosAreas ->${JSON.stringify(areas)}`)
        return this.http.post<AreasInterfaces[]>(apiVucUrl + `api/v1.0/solicitud/areas/${idProyecto}`, areas, {observe: 'response'})
    }

    postColindantes(colindantes: ColindanteItem[]) {
        return this.http.post<ColindanteItem>(apiVucUrl + `api/v1.0/colindantes`, colindantes, {observe: 'response'})
    }

    postDireccion(direccion: DireccionItem) {
        return this.http.post(apiVucUrl + `api/v1.0/direccion`, direccion, {observe: 'response'})
    }

    postElementos(elementos: ElementosTerrenoItem[]) {
        return this.http.post(apiVucUrl + `api/v1.0/elemento-terreno`, elementos, {observe: 'response'})
    }

    postTenencia(propietarios: ProyectoPerfil[]) {
        return this.http.post(apiVucUrl + `api/v1.0/tenencia`, propietarios, {observe: 'response'})
    }

    /**
     * Verifica si el archivo que se va a cargar en el formulario está registrado o si ya existe
     */
    verificar(verificar: FileHash) {
        const headers = new HttpHeaders({
            'Accept': '*/*'
        })
        return this.http.post(apiVucUrl + `api/v1.0/archivos/verificar`, verificar, {
            observe: 'response',
            headers: headers
        },);
    }

    getDistritos(idDepartamento: number) {
        return this.http.get<DistritoItem[]>(apiVucUrl + `api/v1.0/distritos/departamento/${idDepartamento}`, {observe: 'response'})
    }

    getMunicipios(idDistrito: number) {
        return this.http.get<MunicipioItem[]>(apiVucUrl + `api/v1.0/municipios/distrito/${idDistrito}`, {observe: 'response'})
    }

    /**Metodo que convierte los elementos del terreno a las propiredades de la interfaces ElementosTerrenoItem*/
    parseElementoTerreno(elementos: any[]): ElementosTerrenoItem[] {
        if (!elementos || elementos.length === 0) {
            return [];
        }
        return elementos.map((elemento: any) => ({
            idElementoTerreno: parseInt(elemento.id),
            idProyecto: 0,
            estado: elemento.estado
        }));
    }
}
